export default __webpack_public_path__ + "static/media/bankVerificationhelp.6b35f5b2.png";